import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ChevronDownIcon, StarIcon } from 'lucide-react';
import { checkoutUrl, handleCheckoutClick } from '../utils/checkout';
import { FinalOffer } from './FinalOffer';
const testimonials = [{
  name: 'Andrea P.',
  image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=240&q=80',
  quote: 'Por primera vez entendí cómo comer mejor sin sentir culpa por cada comida. Me dio claridad, no más presión.'
}, {
  name: 'Carolina M.',
  image: 'https://images.unsplash.com/photo-1531123897727-8f129e1688ce?auto=format&fit=crop&w=240&q=80',
  quote: 'Tener un plan para la semana me quitó el estrés de pensar qué cocinar todos los días.'
}, {
  name: 'Daniela R.',
  image: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&w=240&q=80',
  quote: 'Lo que más valoro es que siempre tengo una opción para no volver a caer en lo mismo por falta de ideas.'
}, {
  name: 'Paola G.',
  image: 'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?auto=format&fit=crop&w=240&q=80',
  quote: 'Me gustó que parte de ingredientes normales. Pude empezar sin complicar mi compra del supermercado.'
}, {
  name: 'María C.',
  image: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?auto=format&fit=crop&w=240&q=80',
  quote: 'Los complementos me ayudaron a sumar opciones nuevas y a hacer mi rutina de comidas menos repetitiva.'
}, {
  name: 'Valentina A.',
  image: 'https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?auto=format&fit=crop&w=240&q=80',
  quote: 'Pensaba que comer saludable era dejar de disfrutar. Ahora lo siento como una forma más amable de cuidarme.'
}, {
  name: 'Sofía T.',
  image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=240&q=80',
  quote: 'El planificador fue el empujón que necesitaba para pasar de las buenas intenciones a una semana organizada.'
}, {
  name: 'Laura V.',
  image: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?auto=format&fit=crop&w=240&q=80',
  quote: 'Todo está explicado de forma clara. Ya no me siento perdida cuando quiero preparar algo diferente.'
}, {
  name: 'Gabriela N.',
  image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=240&q=80',
  quote: 'Me tranquiliza tener mis ideas, listas y guías reunidas en un mismo lugar.'
}, {
  name: 'Patricia S.',
  image: 'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?auto=format&fit=crop&w=240&q=80',
  quote: 'La estructura de 30 días me ayudó a dejar de improvisar y a sostener mejores decisiones durante la semana.'
}, {
  name: 'Natalia B.',
  image: 'https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?auto=format&fit=crop&w=240&q=80',
  quote: 'Poder consultarlo desde el celular hace más fácil elegir mejor cuando estoy comprando o cocinando.'
}, {
  name: 'Fernanda L.',
  image: 'https://images.unsplash.com/photo-1534751516642-a1af1ef26a56?auto=format&fit=crop&w=240&q=80',
  quote: 'No lo siento como un libro más: es un sistema al que puedo volver cuando necesito orden y motivación.'
}];
const faqs = [['¿Es un libro físico?', 'No. Hábitos para una Vida Saludable es un sistema digital de CÓDIGO FITNESS™ que puedes consultar desde cualquiera de tus dispositivos.'], ['¿Cuándo lo recibo?', 'Inmediatamente después de completar tu compra. Recibirás las indicaciones de acceso en tu correo.'], ['¿Puedo verlo desde mi teléfono?', 'Sí. Está pensado para que puedas consultarlo cómodamente desde tu teléfono, tablet o computadora cuando lo necesites.'], ['¿Necesito experiencia en la cocina?', 'No. El contenido está explicado con pasos claros para acompañarte tanto si estás empezando como si ya cocinas habitualmente.'], ['¿Los ingredientes son fáciles de conseguir?', 'Sí. Se priorizan ingredientes cotidianos y alternativas sencillas para que puedas adaptarlo a tu contexto.'], ['¿Puedo imprimir partes del contenido?', 'Sí, puedes imprimir las secciones que te sean más útiles para organizar tus comidas y tu rutina.']];
export function TrustFooter() {
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  return <>
      <section className="bg-[#fcfbf7] py-24 sm:py-32" data-id="element-359" data-mp="39czx9z8jpdb">
        <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-360" data-mp="37s5rlgu28fz">
          <motion.header initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.55
        }} className="mx-auto max-w-4xl text-center" data-id="element-361" data-mp="88zdjkiz77mn">
            <p className="text-xs font-bold tracking-[0.22em] text-[#6d8063]" data-id="element-362" data-mp="2z7vnzanmx2tu">
              UN SISTEMA QUE TE ACOMPAÑA
            </p>
            <h2 className="font-display mt-5 text-4xl leading-tight text-[#2d3b2c] sm:text-5xl" data-id="element-363" data-mp="2udhnwuy127iu">
              Una guía principal y tres bonos para hacerlo más fácil cada día.
            </h2>
            <div className="mx-auto mt-8 max-w-3xl space-y-5 text-base leading-8 text-[#63705f] sm:text-lg" data-id="element-364" data-mp="2ld327uh5iqet">
              <p data-id="element-365" data-mp="2gifjydcqqs8o">
                No tienes que saltar entre páginas, descargar recursos aislados
                ni decidir desde cero qué hacer cada vez que llega una comida.
              </p>
              <p data-id="element-366" data-mp="26k9ks3ibk07i">
                CÓDIGO FITNESS™ reúne Hábitos para una Vida Saludable y sus
                bonos complementarios para ayudarte a avanzar con más orden,
                confianza y flexibilidad.
              </p>
              <p data-id="element-367" data-mp="1z68q48fomuid">
                Cada recurso cumple una función distinta para que puedas aprender
                a comer mejor, organizarte y volver a tu rutina sin culpa cuando
                la vida se ponga intensa.
              </p>
            </div>
          </motion.header>

          <motion.figure initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.15
        }} transition={{
          duration: 0.65
        }} className="mx-auto mt-16 w-full max-w-6xl" data-id="element-368" data-mp="1u7nqob898euz">
            <img src="https://cdn.magicpatterns.com/uploads/dLbgVhcg6bmJHRqThEgKMo/ChatGPT_Image_17_jul_2026,_09_44_00.png" alt="Sistema Hábitos para una Vida Saludable con planificador nutricional, guía práctica, recetario déficit calórico y cocina antiinflamatoria" className="w-full rounded-2xl object-contain shadow-[0_16px_38px_rgba(64,72,53,0.11)]" data-id="element-369" data-mp="2cxdqjcqvjqtr" />
          </motion.figure>

          <div className="mx-auto mt-16 grid max-w-6xl gap-5 sm:grid-cols-2" data-id="element-370" data-mp="p04o8shxx2qy">
            {[['📗 GUÍA PRINCIPAL', 'Hábitos para una Vida Saludable', 'Una guía para comer mejor, organizarte sin rigidez y crear hábitos que se adapten a tu vida.'], ['🥗 RECETARIO DÉFICIT CALÓRICO', '', 'Un bono con opciones prácticas para quienes quieren crear comidas más ligeras sin dejar de disfrutarlas.'], ['🥬 COCINA ANTIINFLAMATORIA', '', 'Un bono para explorar nuevas recetas, jugos verdes y smoothies que sumen variedad a tu rutina.'], ['📅 PLANIFICADOR NUTRICIONAL', '', 'Un bono para convertir tus intenciones en una semana más organizada, visible y fácil de seguir.']].map(([eyebrow, title, copy], index) => <motion.article key={eyebrow} initial={{
            opacity: 0,
            y: 14
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.2
          }} transition={{
            duration: 0.45,
            delay: index * 0.05
          }} className="rounded-2xl border border-[#e0e5da] bg-[#fffefa] p-7 shadow-[0_8px_22px_rgba(56,69,50,0.05)] sm:p-8" data-id="element-371" data-mp="383w3cgw9hdnd" data-mpi={index}>
                <p className="text-[11px] font-bold tracking-[0.14em] text-[#5d7655]" data-id="element-372" data-mp="3qquw7itl528">
                  {eyebrow}
                </p>
                {title && <h3 className="font-display mt-4 text-2xl text-[#30452e]" data-id="element-373" data-mp="1t72yophe32hi">
                    {title}
                  </h3>}
                <p className={`${title ? 'mt-3' : 'mt-4'} leading-7 text-[#63705f]`} data-id="element-374" data-mp="1o5x7iw3dnna3">
                  {copy}
                </p>
              </motion.article>)}
          </div>

          <motion.aside initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.55
        }} className="mx-auto mt-12 max-w-6xl rounded-[22px] border border-[#d5e0ce] bg-[#edf3e8] p-7 sm:p-10" aria-labelledby="included-system-title" data-id="element-375" data-mp="1f94yqp3tf8lj">
            <h3 id="included-system-title" className="text-xs font-bold tracking-[0.2em] text-[#55704f]" data-id="element-376" data-mp="2qu1xb5rn6ki1">
              TODO INCLUIDO EN TU SISTEMA
            </h3>
            <ul className="mt-7 grid gap-x-8 gap-y-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-377" data-mp="204qah5sy7xuf">
              {['Guía Principal Hábitos para una Vida Saludable', 'Recetario Déficit Calórico', 'Cocina Antiinflamatoria', 'Planificador Nutricional', 'Ideas para acompañar tu rutina', 'Calendario de alimentación de 30 días', 'Meal Prep', 'Smoothies', 'Jugos verdes', 'Menús completos', 'Herramientas para hábitos duraderos', 'Compatible con celular, tablet y computadora', 'Acceso inmediato después de la compra'].map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-6 text-[#4f614b]" data-id="element-378" data-mp="36q2dzn4q7ljh">
                  <CheckIcon className="mt-1 shrink-0 text-[#638359]" size={15} strokeWidth={2.3} aria-hidden="true" data-id="element-379" data-mp="3lfvksv7qpakr" />
                  <span data-id="element-380" data-mp="3cdmbu9s4dp9h">{item}</span>
                </li>)}
            </ul>
          </motion.aside>

          <aside className="mx-auto mt-8 max-w-6xl rounded-[22px] border border-[#dae6d3] bg-[#f1f6ed] px-7 py-8 sm:px-10 sm:py-10" data-id="element-381" data-mp="3gdxwhmkhfpky">
            <h3 className="font-display text-2xl leading-tight text-[#395237] sm:text-3xl" data-id="element-382" data-mp="37eswscx6pq77">
              Empieza con una guía; sostén el cambio con herramientas reales.
            </h3>
            <div className="mt-4 max-w-4xl space-y-3 leading-7 text-[#5a6b55]" data-id="element-383" data-mp="2sobyv3jrdif2">
              <p data-id="element-384" data-mp="2xn6oopg5878o">
                En lugar de seguir acumulando consejos sueltos, tendrás un lugar
                claro al que volver cuando necesites ideas, estructura o impulso.
              </p>
              <p data-id="element-385" data-mp="2oqnxpirh2teq">
                Todo está organizado para que abras el sistema, encuentres lo que
                necesitas y avances a tu propio ritmo.
              </p>
            </div>
          </aside>

          <div className="mx-auto mt-12 max-w-5xl text-center" data-id="element-386" data-mp="pftfb0ly7g0v">
            <a href={checkoutUrl} onClick={handleCheckoutClick} className="inline-flex min-h-16 w-full items-center justify-center rounded-full bg-[#3f603d] px-8 text-sm font-bold tracking-[0.07em] text-white shadow-[0_12px_24px_rgba(48,69,46,0.16)] transition duration-300 hover:-translate-y-0.5 hover:bg-[#304d30] hover:shadow-[0_16px_30px_rgba(48,69,46,0.22)]" data-id="element-387" data-mp="kjcsqaued9pw">
              QUIERO MI SISTEMA COMPLETO
            </a>
            <div className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-3 text-xs font-medium text-[#5c6c57]" data-id="element-388" data-mp="z88vpthljwjn">
              <span data-id="element-389" data-mp="3oxjb2ld4byr6">🔒 Pago 100% seguro</span>
              <span data-id="element-390" data-mp="3ouf1t9ksqctn">⚡ Acceso inmediato</span>
              <span data-id="element-391" data-mp="3jwn6e5ky08kp">📥 Descarga digital</span>
              <span data-id="element-392" data-mp="3k01bvmowkxwd">💚 Acceso para siempre</span>
              <span data-id="element-393" data-mp="1zgp56q57gsw2">📱 Compatible con todos los dispositivos</span>
            </div>
          </div>

          <div className="mx-auto mt-16 max-w-3xl text-center" data-id="element-394" data-mp="24fsbedwx955m">
            <p className="font-display text-2xl leading-9 text-[#3f563b] sm:text-3xl" data-id="element-395" data-mp="28gc4n6edjomh">
              No necesitas una versión perfecta de ti. Necesitas una forma más
              amable y clara de cuidarte.
            </p>
            <p className="mt-6 leading-8 text-[#62705f]" data-id="element-396" data-mp="2i6x1aoahmj2r">
              El primer paso puede ser pequeño: aprender qué elegir hoy, preparar
              una comida distinta mañana y volver a intentarlo las veces que sea
              necesario. Así se construyen hábitos que duran.
            </p>
            <p className="font-display mt-7 text-2xl text-[#3f563b]" data-id="element-397" data-mp="2w66klwtzptay">
              Tu bienestar también merece una guía.
            </p>
          </div>
        </div>
      </section>

      <section className="bg-[#fcfbf7] py-24 sm:py-32" data-id="element-398" data-mp="11rm0bl9kzzs3">
        <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-399" data-mp="11s5k77isky8r">
          <div className="grid gap-8 lg:grid-cols-[1.2fr_.8fr] lg:items-end" data-id="element-400" data-mp="6gxn4mwxrvjc">
            <div data-id="element-401" data-mp="2gdqrlk6svy9">
              <p className="text-xs font-bold tracking-[0.2em] text-[#6d8063]" data-id="element-402" data-mp="2gvji87n4s1f">
                EXPERIENCIAS DE LA COMUNIDAD
              </p>
              <h2 className="font-display mt-5 max-w-3xl text-4xl leading-tight text-[#2d3b2c] sm:text-5xl" data-id="element-403" data-mp="gf3mawrcynki">
                Cuando comer mejor deja de sentirse como una lucha, todo empieza
                a cambiar.
              </h2>
            </div>
            <div className="border-l-2 border-[#b3c3a8] pl-5 text-sm leading-7 text-[#667361] sm:pl-7" data-id="element-404" data-mp="3eyaay2uy47q1">
              <p data-id="element-405" data-mp="3tmopvc5mzmmy">
                Cada persona vive un proceso diferente. Estos comentarios
                representan lo que suelen valorar quienes buscan una forma más
                práctica, rica y sostenible de alimentarse.
              </p>
              <p className="mt-4" data-id="element-406" data-mp="31419ga1l4vs7">
                Nuestro objetivo es darte herramientas para que puedas construir
                hábitos que se queden contigo a largo plazo.
              </p>
              <p className="mt-5 text-xs leading-5 text-[#7c8878]" data-id="element-407" data-mp="1bmvwkkgl3wrm">
                Comentarios representativos e ilustrativos de la comunidad; no
                corresponden a reseñas verificadas de compradores.
              </p>
            </div>
          </div>

          <div className="-mx-5 mt-14 flex snap-x snap-mandatory gap-4 overflow-x-auto px-5 pb-5 md:mx-0 md:grid md:grid-cols-4 md:gap-5 md:overflow-visible md:px-0 md:pb-0" data-id="element-408" data-mp="16qoz7g297tla">
            {testimonials.map((testimonial, index) => <motion.article key={testimonial.name} initial={{
            opacity: 0,
            y: 14
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.12
          }} transition={{
            duration: 0.42,
            delay: index % 4 * 0.05
          }} className="flex min-h-[290px] min-w-[278px] snap-start flex-col rounded-2xl border border-[#e1e4da] bg-[#fffefa] p-6 shadow-[0_9px_22px_rgba(56,69,50,0.06)] transition duration-300 md:min-w-0 md:hover:-translate-y-1 md:hover:shadow-[0_15px_30px_rgba(56,69,50,0.11)]" data-id="element-409" data-mp="1zcgpnw6gcaem" data-mpi={index}>
                <div className="flex items-center justify-between gap-3" data-id="element-410" data-mp="22unx30tnpiy0">
                  <img src={testimonial.image} alt={`Avatar ilustrativo de ${testimonial.name}`} className="h-11 w-11 rounded-full object-cover" data-id="element-411" data-mp="1xyp4t257jgsb" />
                  <div className="flex text-[#a57d2a]" aria-label="5 de 5 estrellas" data-id="element-412" data-mp="1o116y3cb1t5x">
                    {Array.from({
                  length: 5
                }).map((_, starIndex) => <StarIcon key={starIndex} fill="currentColor" size={13} data-id="element-413" data-mp="3ec5k2on0q3xu" data-mpi={starIndex} />)}
                  </div>
                </div>
                <blockquote className="mt-6 text-[15px] leading-7 text-[#4e5c4a]" data-id="element-414" data-mp="152zcprqkowt8">
                  “{testimonial.quote}”
                </blockquote>
                <p className="mt-auto border-t border-[#e5e7df] pt-5 text-sm font-semibold text-[#40533d]" data-id="element-415" data-mp="19u7qt12ul6cq">
                  {testimonial.name}
                </p>
              </motion.article>)}
          </div>

          <aside className="mt-12 border border-[#d8e1d0] bg-[#eef3e9] px-7 py-8 sm:px-10 sm:py-9" aria-labelledby="decision-title" data-id="element-416" data-mp="h73d87povjpc">
            <div className="flex flex-col gap-5 sm:flex-row sm:items-start" data-id="element-417" data-mp="q4x7ld3w839v">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#fffefa] text-[#a57d2a] shadow-sm" aria-hidden="true" data-id="element-418" data-mp="v51r7c03le4b">
                <StarIcon fill="currentColor" size={20} data-id="element-419" data-mp="26ix7io2qnsx4" />
              </span>
              <div data-id="element-420" data-mp="1i6v8ten3qua9">
                <h3 id="decision-title" className="font-display text-3xl text-[#354a33]" data-id="element-421" data-mp="1i8g4j7l5kj9p">
                  Tu cambio empieza con una decisión pequeña
                </h3>
                <p className="mt-4 max-w-4xl leading-7 text-[#586754]" data-id="element-422" data-mp="1r19ovjfgi8uf">
                  No necesitas prometerte que nunca fallarás. Solo puedes elegir
                  tener una guía cuando quieras volver a cuidarte. Hábitos para
                  una Vida Saludable fue creado para ayudarte a comer con más
                  orden, disfrutar más tus comidas y construir una rutina que
                  puedas retomar una y otra vez. Tu acceso está listo cuando tú
                  decidas empezar.
                </p>
              </div>
            </div>
          </aside>
        </div>
      </section>

      <section id="preguntas" className="bg-[#e9ebdf] py-24 sm:py-32" data-id="element-423" data-mp="fktcy0342acb">
        <div className="mx-auto grid max-w-6xl gap-12 px-5 sm:px-8 lg:grid-cols-[.7fr_1.3fr]" data-id="element-424" data-mp="bjzn3163ylgs">
          <div data-id="element-425" data-mp="1g2k3a3f92k5">
            <p className="text-xs font-bold tracking-[0.2em] text-[#6d8063]" data-id="element-426" data-mp="1fjconbedwkd">
              TODO CLARO
            </p>
            <h2 className="font-display mt-5 text-4xl leading-tight text-[#2d3b2c] sm:text-5xl" data-id="element-427" data-mp="5ipdhffqqvjg">
              Preguntas frecuentes
            </h2>
            <p className="mt-6 max-w-sm leading-7 text-[#62705e]" data-id="element-428" data-mp="3ssvt9ga7lgbp">
              Resolvemos las dudas más comunes para que puedas decidir con
              tranquilidad. Si necesitas ayuda adicional, nuestro equipo de
              soporte estará encantado de orientarte.
            </p>
          </div>
          <div className="border-t border-[#cfd5c7]" data-id="element-429" data-mp="34wi1fapsa956">
            {faqs.map(([question, answer], index) => {
            const isOpen = openFaq === index;
            return <div key={question} className="border-b border-[#cfd5c7]" data-id="element-430" data-mp="133ttio272xj2" data-mpi={index}>
                  <button type="button" onClick={() => setOpenFaq(isOpen ? null : index)} className="flex w-full items-center justify-between gap-5 py-6 text-left font-medium text-[#384b36]" aria-expanded={isOpen} data-id="element-431" data-mp="132ilud5mp5mo">
                    <span data-id="element-432" data-mp="21pq6evqa590a">{question}</span>
                    <ChevronDownIcon className={`shrink-0 transition-transform ${isOpen ? 'rotate-180' : ''}`} size={20} data-id="element-433" data-mp="21qrjt6urq7l6" />
                  </button>
                  {isOpen && <div className="max-w-xl pb-6 leading-7 text-[#62705e]" data-id="element-434" data-mp="2zd6w7u8c8f1v">
                      {answer}
                    </div>}
                </div>;
          })}
          </div>
        </div>
      </section>

      <FinalOffer data-id="element-435" data-mp="2pdpu1msaojan" />

      <footer className="bg-[#263624] px-5 py-12 text-[#d8e1d0] sm:px-8" data-id="element-436" data-mp="2pd7r67b4n6tr">
        <div className="mx-auto max-w-7xl" data-id="element-437" data-mp="19xhabsydqio8">
          <div className="flex flex-col gap-8 sm:flex-row sm:items-start sm:justify-between" data-id="element-438" data-mp="1a0mzf870dkjy">
            <div data-id="element-439" data-mp="1dxj31cm501rd">
              <p className="text-xs font-bold tracking-[0.18em] text-white" data-id="element-440" data-mp="16g30ayo8unab">
                CÓDIGO FITNESS™
              </p>
              <p className="mt-4 max-w-xs text-sm leading-6" data-id="element-441" data-mp="11g8a6xcam1qb">
                “Pequeños cambios diarios pueden transformar toda una vida.”
              </p>
            </div>
            <nav className="flex flex-wrap gap-x-6 gap-y-3 text-xs" aria-label="Enlaces legales" data-id="element-442" data-mp="1bfpg9fvgihmt">
              <a href="/politica-de-privacidad" className="transition-colors hover:text-white" data-id="element-443" data-mp="nqn06cgh0wuf">
                Política de Privacidad
              </a>
              <a href="/terminos-y-condiciones" className="transition-colors hover:text-white" data-id="element-444" data-mp="xgg7305o4nsc">
                Términos y Condiciones
              </a>
              <a href="/politica-de-reembolsos" className="transition-colors hover:text-white" data-id="element-445" data-mp="4y2ilr682e5x">
                Política de Reembolsos
              </a>
              <a href="/descargo-de-responsabilidad" className="transition-colors hover:text-white" data-id="element-446" data-mp="pnwr0lpg9y56">
                Descargo de Responsabilidad
              </a>
            </nav>
          </div>

          <div className="mt-10 border-t border-[#719061]/30 pt-7" data-id="element-447" data-mp="13fte2bc9hhup">
            <p className="max-w-4xl text-xs leading-6 text-white/75" data-id="element-448" data-mp="13f1hax6xhe2u">
              Al completar tu compra aceptas nuestros Términos y Condiciones.
              Debido a la naturaleza digital de este producto y al acceso
              inmediato a todos los archivos descargables, no se aceptan
              devoluciones, cambios ni reembolsos una vez confirmada la compra.
            </p>
            <p className="mt-5 text-xs text-white/75" data-id="element-449" data-mp="kqwjs7gv6pch">
              © 2026 Código Fitness™. Todos los derechos reservados.
            </p>
          </div>
        </div>
      </footer>
    </>;
}